module.exports = __webpack_public_path__ + "static/media/sa.e9b568d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sa.svg
// module id = 238
// module chunks = 0